export const parseValidId = (id: string | undefined) => {
	if (id?.match(/^[0-9a-zA-Z]+$/)) {
		return id;
	}
	return null;
};
